import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";

function Opener (props) {

    const updateStep = props.updateStep

    useEffect(() => {})

    return (
        <div className="panel">
            <div className="panel_content">
                <h1>Hello!</h1>
                <div>
                    <p style={{marginBottom: '8px'}}>This is <strong>provocative platform</strong> to collectively discuss about how <nobr>text-to-image</nobr> AI models depict all the different labels in the gender spectrum.</p>
                    <p style={{marginBottom: '8px'}}>The platform tests if the perceived genders of the <nobr>AI-generated</nobr> images match with their original prompts.</p>
                    <p style={{marginBottom: '32px'}}>The aim is to <strong>elicit gender presentation stereotypes</strong> and <strong>critically discuss</strong> what we should expect from visual AI.</p>
                    <h6>Head of research: <strong>Fe Simeoni</strong> <a href="mailto:federico.simeoni@student.unibz.it">federico.simeoni@student.unibz.it</a><br/>PhD Computer Science student at the Free University<br/>of Bozen-Bolzano and Eurac Research (Italy).</h6>
                </div>
                <button className="button_primary" onClick={() => updateStep('.panel', 1)} style={{margin:"15px 0 0 0"}}>Start evaluating AI</button>
            </div>
            <div className="panel_footer" style={{backgroundImage:'url("./img/PNRR_loghi.png'}}></div>
        </div>
    )
}

export default Opener;